import type { ReactNode } from "react";

type Tone = "success" | "muted" | "warning" | "danger";

const TONE_CLASSES: Record<Tone, string> = {
  success: "bg-success-soft text-success border-success/40",
  muted: "bg-bg/60 text-fg-muted border-outline",
  warning: "bg-warning-soft text-warning border-warning/40",
  danger: "bg-danger-soft text-danger border-danger/40",
};

interface StatusPillProps {
  tone: Tone;
  children: ReactNode;
  testid?: string;
}

export function StatusPill({ tone, children, testid }: StatusPillProps) {
  return (
    <span
      data-testid={testid}
      className={`inline-flex items-center px-2 py-0.5 rounded-md text-xs border ${TONE_CLASSES[tone]}`}
    >
      {children}
    </span>
  );
}
